import React, { useMemo } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";
const THU_VI = [
  "Chủ nhật",
  "Thứ hai",
  "Thứ ba",
  "Thứ tư",
  "Thứ năm",
  "Thứ sáu",
  "Thứ bảy",
];

const BoltDateTabs = ({ activeTab, onChange }) => {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];

    options.push({
      value: "live",
      label: "Kèo trực tuyến",
    });

    options.push({
      value: todayString,
      label: "Hôm nay",
      dateLabel: today.format("DD/MM"),
    });

    const tomorrow = today.clone().add(1, "day");
    options.push({
      value: tomorrow.format("YYYY-MM-DD"),
      label: "Ngày mai",
      dateLabel: tomorrow.format("DD/MM"),
    });

    for (let i = 2; i <= 6; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: THU_VI[d.day()],
        dateLabel: d.format("DD/MM"),
      });
    }

    return options;
  }, [today, todayString]);

  return (
    <div className="flex w-full h-full min-h-0 items-stretch">
      <div className="kbv-date-tabs-scroll flex h-full w-full min-w-0 gap-[12px] overflow-x-auto overflow-y-hidden scroll-smooth items-center pb-1">
        {dateOptions.map((opt) => {
          const isSelected = activeTab === opt.value;
          return (
            <div 
              key={opt.value}
              onClick={() => onChange && onChange(opt.value)}
              className={`
                kbv-date-tab flex flex-col items-center justify-center box-border cursor-pointer transition-all duration-300 ease-in-out
                px-[11px] py-[6px] rounded-[8px] shrink-0 min-h-[50px]
                ${isSelected 
                    ? "kbv-date-tab--selected pointer-events-none font-[700]" 
                    : "kbv-date-tab--unselected hover:text-[var(--theme-primary)] font-[700]"}
              `}
            >
              <span className="whitespace-nowrap text-[14px] leading-[18px]">{opt.label}</span>
              {opt.dateLabel ? (
                <span className="kbv-date-label whitespace-nowrap font-[500] text-[12px] leading-[14px] mt-[2px]">
                  {opt.dateLabel}
                </span>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BoltDateTabs;
